export default "__VITE_ASSET__B_rorY1r__"